import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToMenu = () => {
    document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1641848462266-0a0e1a586307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxicmF6aWxpYW4lMjBjb3hpbmhhJTIwc25hY2t8ZW58MHx8fHwxNzc5MDE2NTUxfDA&ixlib=rb-4.1.0&q=85)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#291014]/85 via-[#7F1D1D]/70 to-[#FAF8F5]"></div>
      </div>

      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-10 left-10 text-[#EA580C] text-4xl">★</div>
        <div className="absolute top-20 right-20 text-[#EA580C] text-3xl">★</div>
        <div className="absolute bottom-32 left-1/4 text-[#EA580C] text-2xl">★</div>
        <div className="absolute bottom-20 right-1/3 text-[#EA580C] text-3xl">★</div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto py-16">
        <img
          src="/images/logo.png"
          alt="Petiscaria Camamu"
          className="h-44 sm:h-56 w-auto mx-auto mb-6 drop-shadow-2xl"
          data-testid="hero-logo"
        />
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
          data-testid="hero-title"
        >
          Petiscaria Camamu
        </h1>
        <p
          className="text-lg sm:text-xl text-white/90 mb-8 max-w-2xl mx-auto"
          style={{ fontFamily: 'Manrope, sans-serif' }}
          data-testid="hero-subtitle"
        >
          Os melhores petiscos artesanais da região! Combos especiais, salgados
          fresquinhos e muito mais. Peça agora e receba no conforto de casa.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={scrollToMenu}
            size="lg"
            className="bg-[#EA580C] hover:bg-[#C2410C] text-white font-semibold px-8 py-6 text-lg rounded-full shadow-2xl hover:shadow-xl transition-all"
            data-testid="hero-cta-button"
          >
            Ver Cardápio
            <ChevronDown className="ml-2 h-5 w-5" />
          </Button>
          <div
            className="text-white/90 text-sm bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="hero-min-order"
          >
            Pedido mínimo: R$ 30,00
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
